export enum Action {
	SUGGEST = 'SUGGEST',
	ACCEPT = 'ACCEPT',
	REJECT = 'REJECT',
}

export type Suggestion = {
	id: string;
	title: string;
	description: string;
	url: string;
	parentId: number | null;
	action: Action;
};

export const PRODUCT_ICON_MAP: Array<{
	pattern: string;
	product: string;
	iconUrl: string;
}> = [
	{
		pattern: 'docs.google.com/document',
		product: 'Google Docs',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
	},
	{
		pattern: 'docs.google.com/spreadsheets',
		product: 'Google Sheets',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png',
	},
	{
		pattern: 'docs.google.com/presentation',
		product: 'Google Slides',
		iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico',
	},
	{
		pattern: 'drive.google.com',
		product: 'Google Drive',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
	},
	{
		pattern: 'loom.com',
		product: 'Loom',
		iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico',
	},
	{
		pattern: 'figma.com',
		product: 'Figma',
		iconUrl: 'https://static.figma.com/app/icon/1/favicon.ico',
	},
	{
		pattern: 'slack.com',
		product: 'Slack',
		iconUrl: 'https://slack.com/favicon.ico',
	},
];

export const DEFAULT_PRODUCT_INFO = {
	product: 'Link',
	iconUrl: '',
};
